exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-69e8276c] {\n  cursor: pointer;\n  opacity: 0.5;\n  transition: 0.1s all linear;\n}\nimg[data-v-69e8276c]:hover {\n    opacity: 0.75;\n}\n", ""]);

// exports
